// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3FpcU","notes":"Notes_notes__1qTvA"};